import { Box, Button } from "@mui/material";
// import { useQueryClient } from "@tanstack/react-query";
import { FormikProps } from "formik";
import { isEmpty } from "lodash";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Flex from "../../../../../../../../../../components/Flex";
// import PdfViewDrawer from "../../../../../../../../../../components/PdfViewDrawer";
import RenderWithTooltip from "../../../../../../../../../../components/RenderWithTooltip";
import Text from "../../../../../../../../../../components/Text";
import { useQueryParams } from "../../../../../../../../../../hooks/use-query-param";
import { useReduceDisclosure } from "../../../../../../../../../../hooks/use-reduce-disclosure";
import { useArchiveState } from "../../../../../../../../../../hooks/useArchiveState";
import { useRosCarePlanTemplateArchive } from "../../../../../../../../../../queries/encounter/use-ros-care-plan-template-archive";
import { useGetOrderPrescription } from "../../../../../../../../../../queries/patient-chart/order/prescription/get-all-prescription";
// import { usePrescriptionPrintById } from "../../../../../../../../../../queries/patient-chart/order/prescription/use-get-prescription-print-by-uuid";
import useCurrentUser from "../../../../../../../../../../hooks/local-storage/use-current-user";
import useDisclosure from "../../../../../../../../../../hooks/use-disclosure";
import { useArchivePrescription } from "../../../../../../../../../../queries/patient-chart/order/prescription/use-prescription-archive";
import { useArchiveOrder } from "../../../../../../../../../../queries/patient-chart/order/use-archive-order";
import { useGetOrders } from "../../../../../../../../../../queries/patient-chart/order/use-get-orders";
import { useGetPatientScriptsureUrl } from "../../../../../../../../../../queries/script-sure/use-get-patient-scriptsure-url";
import { useNewTemplateList } from "../../../../../../../../../../queries/template/new-flow/use-new-template-list";
import { useArchiveVaccine } from "../../../../../../../../../../queries/vaccines/use-patient-vaccine-archive";
import { usePatientVaccinesList } from "../../../../../../../../../../queries/vaccines/use-patient-vaccines";
import { GetScriptsureProfileUrlTypeEnum } from "../../../../../../../../../../services";
import { NonNullableDate } from "../../../../../../../../../../utils/date-time-utility";
import {
  DEFAULT_FONTSIZE,
  DEFAULT_UUID_NAME_LIST,
  DEFAULT_VALUE_LABEL_LIST,
  camelCaseToTitle,
  DEF_PAGINATION,
  getFormattedId,
  getXtenantId,
  replaceUnderScoreAddSpace,
  transformMultiSelectFrontEndVal,
} from "../../../../../../../../../../utils/utils";
import UpsertLabRequisitionForm from "../../../../../../../scheduling/appointment/encounter/default-forms/UpsertLabRequisitionForm";
import { StyleAddButton } from "../../../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledAddButton";
import UpsertPrescriptionForm from "../../../../../../../scheduling/appointment/encounter/prescription/UpsertPrescriptionForm";
import CarePlanTemplateModal from "../../../../care-plan/CarePlanTemplateModal";
import PrintOrders from "../../../../order/orders/PrintOrders";
import { getTransPayload } from "../../../../order/prescription/OrderPrescriptionTableNew";
import { PrescriptionsPopUp } from "../../../../order/prescription/PrescriptionsPopUp";
import PrintPrescription from "../../../../order/prescription/PrintPrescription";
import UpsertVaccineDrawer from "../../../../vaccines/UpsertVaccineDrawer";
import UpsertVitalFormDrawerNew from "../../../../vitals/UpsertVitalFormDrawerNew";
import { AddCptCodes, renderSelectedCptCodes } from "./Add-CPT-Codes";
import PreviewContentWrapper from "./PreviewContentWrapper";
import ReferringOutPatientWrapper from "./ReferringOutPatientWrapper";

interface Props {
  formik: FormikProps<any>;
}

const PsychiatricNotePlan = (props: Props) => {
  const { formik } = props;
  const [
    addVitalDisclosure,
    cptDisclosure,
    prescriptionDisclosure,
    ordersDisclosure,
    vaccineDisclosure,
    carePlanDisclosure,
    referralDisclosure,
    printViewDisclosure,
    printOrderDisclosure,
  ] = useReduceDisclosure(9);
  const { patientId } = useParams();
  const appointmentId = useQueryParams("appointmentid");
  const { mutateAsync: archivePrescription } = useArchivePrescription();
  const { mutateAsync: archiveVaccine } = useArchiveVaccine();
  const { data: allPrescription, refetch } = useGetOrderPrescription({
    appointmentUuid: appointmentId ?? "",
    pagination: DEF_PAGINATION,
    patientUuid: patientId as any,
    archive: false,
    xTENANTID: getXtenantId(),
  });

  const { data: orders, refetch: refetchOrders } = useGetOrders({
    // patientUuid: patientid ?? "",
    appointmentUuid: appointmentId ?? "",
    archive: false,
    pagination: DEF_PAGINATION,
    xTENANTID: getXtenantId(),
  });

  const { data: vaccineList, refetch: refreshVaccine } = usePatientVaccinesList(
    {
      appointmentId: appointmentId ?? "",
      // patientUuid: patientId as string,
      pagination: DEF_PAGINATION,
      archive: false,
      xTENANTID: getXtenantId(),
    }
  );

  const { mutateAsync: archiveOrder } = useArchiveOrder();
  const { mutateAsync: archiveTemplate } = useRosCarePlanTemplateArchive();

  function orderArchiveHandler<T>(value: boolean, id: T) {
    return archiveOrder({
      patientOrderId: id?.toString() ?? "",
      status: value,
      xTENANTID: getXtenantId(),
    }).then((res) => {
      refetchOrders();
      return res;
    });
  }
  const { archiveHandler } = useArchiveState(archiveTemplate);

  function prescriptionArchiveHandler<T>(value: boolean, id: T) {
    return archivePrescription({
      prescriptionFormId: id?.toString() ?? "",
      status: value,
      xTENANTID: getXtenantId(),
    }).then((res) => {
      refetch();
      return res;
    });
  }

  function vaccineArchiveHandler<T>(value: boolean, id: T) {
    return archiveVaccine({
      patientVaccineId: id?.toString() ?? "",
      status: value,
      xTENANTID: getXtenantId(),
    }).then((res) => {
      refreshVaccine();
      return res;
    });
  }

  const { data: carePlanTemplates, refetch: refetchCarePlanTemplates } =
    useNewTemplateList({
      pagination: {
        page: 0,
        pageSize: 50,
      },
      templateType: "CARE_PLAN",
      xTENANTID: getXtenantId(),
      archive: false,
      appointmentUuid: appointmentId ?? "",
    });

  const [showIframe, setShowIframe] = useState(false);
  const [shouldFetchUrl, setShouldFetchUrl] = useState(false);
  const user = sessionStorage.getItem("user");
  const providerId = user ? JSON.parse(user ?? "")?.uuid : null;
  const [me] = useCurrentUser();

  const {
    data: patientScriptsureUrl,
    isLoading,
    error,
  }: any = useGetPatientScriptsureUrl({
    patientUuid: patientId ?? "",
    providerId: providerId ?? "",
    xTENANTID: getXtenantId() ?? "",
    type: GetScriptsureProfileUrlTypeEnum.Prescription,
    enabled: shouldFetchUrl, // Only fetch when shouldFetchUrl is true
  });

  const handleOpenIframe = () => {
    setShowIframe(true);
  };

  const handleCloseIframe = () => {
    setShowIframe(false);
  };

  const handleElectronicPrescription = () => {
    setShouldFetchUrl(true);
  };
  React.useEffect(() => {
    if (shouldFetchUrl && patientScriptsureUrl?.data && !isLoading && !error) {
      handleOpenIframe();
      setShouldFetchUrl(false); // Reset the flag
    }
  }, [shouldFetchUrl, patientScriptsureUrl, isLoading, error]);

  React.useEffect(() => {
    if (carePlanTemplates?.data?.content?.length) {
      formik.setFieldValue("carePlans", carePlanTemplates?.data?.content);
    }
  }, [carePlanTemplates]);

  const [prefillData, setPrefillData] = useState<any>(null);
  // const { mutateAsync: printPrescription } = usePrescriptionPrintById();
  // const queryClient = useQueryClient();
  const getReferralPrint = async (prescriptionId: string) => {
    // printPrescription({
    //   prescriptionFormId: prescriptionId,
    //   hasStatusChange: true,
    //   xTENANTID: getXtenantId() as string,
    // }).then((res) => {
    //   const blob = new Blob([res?.data], { type: "application/pdf" });
    //   const fileUrl = URL.createObjectURL(blob);
    //   printViewDisclosure.open(fileUrl);

    //   queryClient.invalidateQueries({
    //     queryKey: ["patient-prescription-list"],
    //   });
    // });
    printViewDisclosure.open(prescriptionId);
  };

  return (
    <>
      {!!formik.values?.procedureCodes?.length && (
        <Flex flexDirection={"column"} width={"100%"} gap={1}>
          {/* <Text fontWeight={"bold"}>CPT Codes</Text> */}
          {renderSelectedCptCodes(
            formik.values?.procedureCodes ?? [],
            (code: any) => {
              formik.setFieldValue("procedureCodes", [
                ...(formik.values?.procedureCodes ?? []).filter(
                  (it: any) => it.value !== code.value
                ),
              ]);
            },
            "20vh"
          )}
        </Flex>
      )}

      {/* prescription */}
      {!!allPrescription?.data?.content?.length && (
        <PrescriptionPreview
          data={allPrescription?.data?.content}
          onDelete={(uuid) => {
            prescriptionArchiveHandler(true, uuid).then(() => {});
          }}
          onEdit={(prescription) => {
            setPrefillData(getTransPayload(prescription));
            prescriptionDisclosure.open(prescription.uuid);
          }}
        />
      )}

      {/* vaccine */}
      {!!vaccineList?.data?.content?.length && (
        <PreviewContentWrapper
          dataList={vaccineList?.data?.content}
          k="vaccine"
          title="Immunization"
          renderContent={(vaccine: any) => {
            // Match the encounter-summary Immunizations format
            // ({name} : {dose} {units} by {route} on {site}) — ECRH-5428.
            const detail = [
              vaccine?.dose || "",
              vaccine?.units || "",
              vaccine?.route
                ? `by ${replaceUnderScoreAddSpace(vaccine.route.toLowerCase())}`
                : "",
              vaccine?.site
                ? `on ${replaceUnderScoreAddSpace(vaccine.site.toLowerCase())}`
                : "",
            ]
              .filter(Boolean)
              .join(" ");
            return (
              <Text sx={{ color: "#424242" }}>
                {`${vaccine?.vaccine?.name || "-"}${
                  detail ? ` : ${detail}` : ""
                }`}
              </Text>
            );
          }}
          onDelete={(uuid) => {
            vaccineArchiveHandler(true, uuid).then(() => {});
          }}
          onEdit={(vaccine) => {
            vaccineDisclosure.open({
              ...vaccine,
              vaccine: {
                value: vaccine?.vaccine?.uuid,
                label: vaccine?.vaccine?.name,
              },
              administeredBy: vaccine?.administeredBy
                ? {
                    value: Object.keys(vaccine.administeredBy)[0],
                    label: Object.values(vaccine.administeredBy)[0],
                  }
                : undefined,
            });
          }}
        />
      )}

      {/* orders */}
      {!!orders?.data?.content?.length && (
        <PreviewContentWrapper
          dataList={orders?.data?.content}
          k="order"
          title="Orders"
          renderContent={(it) => (
            <Flex flexDirection={"column"} gap={1}>
              <Text>{`${it?.orderTitle || ""}, ${
                it?.orderType ?? ""
              } - ${NonNullableDate(it?.appointmentDate)} - ${
                it?.providerName
              } `}</Text>
              <Flex flexDirection={"column"} gap={0.5}>
                <Text fontWeight={"bold"}>Tests:</Text>
                {it?.tests
                  ? Object.values(it?.tests ?? {}).map(
                      (it: any, ind: number) => {
                        return (
                          <Flex gap={0.5} key={it.uuid}>
                            <Text>{ind + 1}.</Text>
                            <Text>{it}</Text>
                          </Flex>
                        );
                      }
                    )
                  : ""}
              </Flex>
            </Flex>
          )}
          onPrint={(uuid) => {
            printOrderDisclosure.open(uuid);
          }}
          onDelete={(uuid) => orderArchiveHandler(true, uuid).then(() => {})}
          onEdit={(order) => {
            const transformedData = {
              ...order,
              location: transformMultiSelectFrontEndVal(
                DEFAULT_UUID_NAME_LIST,
                order?.location
              ),
              labs: transformMultiSelectFrontEndVal(
                DEFAULT_VALUE_LABEL_LIST,
                order?.labs
              ),
              tests: transformMultiSelectFrontEndVal(
                DEFAULT_UUID_NAME_LIST,
                order?.tests
              ),
              medicalCodes: transformMultiSelectFrontEndVal(
                DEFAULT_UUID_NAME_LIST,
                order?.medicalCodes
              ),
              imagingCenter: order?.imagingCenter ?? undefined,
              primaryProvider: order?.primaryProvider
                ? {
                    value: Object.keys(order.primaryProvider)[0],
                    label: Object.values(order.primaryProvider)[0],
                  }
                : undefined,
              orderingProvider: order?.orderingProvider
                ? {
                    value: Object.keys(order.orderingProvider)[0],
                    label: Object.values(order.orderingProvider)[0],
                  }
                : undefined,
              patientInstructions: order?.patientInstruction ?? undefined,
            };

            ordersDisclosure.open(transformedData);
          }}
        />
      )}

      {/* Care Plan */}
      {!!carePlanTemplates?.data?.content?.length && (
        <PreviewContentWrapper
          dataList={carePlanTemplates?.data?.content}
          k="rosTemplate"
          title="Care Plan Templates"
          renderContent={(carePlanTemplate: any) => (
            <Box>
              <Text fontSize={DEFAULT_FONTSIZE} fontWeight="500" mb={1}>
                Template Name :
                <RenderWithTooltip
                  value={carePlanTemplate?.templateName ?? ""}
                />
              </Text>

              <Text fontSize={DEFAULT_FONTSIZE} fontWeight="500" mb={1}>
                Goals :
                <RenderWithTooltip value={carePlanTemplate?.goals} />
              </Text>

              <Text fontSize={DEFAULT_FONTSIZE} fontWeight="500" mb={1}>
                Intervention & Tasks :
                <RenderWithTooltip value={carePlanTemplate?.intervention} />
              </Text>

              <Text fontSize={DEFAULT_FONTSIZE} fontWeight="500" mb={1}>
                Prevention Schedule :
                <RenderWithTooltip
                  value={carePlanTemplate?.preventive_schedule}
                />
              </Text>
            </Box>
          )}
          onDelete={(uuid) => {
            archiveHandler(true, uuid).then((res) => {
              refetchCarePlanTemplates();
              return res;
            });
          }}
          onEdit={(carePlan) => {
            const transformedTemplateData = {
              ...carePlan,
              speciality: isEmpty(carePlan?.speciality)
                ? undefined
                : transformMultiSelectFrontEndVal(
                    DEFAULT_VALUE_LABEL_LIST,
                    (carePlan as any).speciality
                  ),
              icdCodes: isEmpty(carePlan?.icdCodes)
                ? undefined
                : transformMultiSelectFrontEndVal(
                    DEFAULT_VALUE_LABEL_LIST,
                    (carePlan as any).icdCodes
                  ),
            };
            carePlanDisclosure.open(transformedTemplateData);
          }}
        />
      )}

      {/* Action Buttons */}
      <Flex gap={1} flexWrap="wrap" sx={{ mb: 1 }}>
        <PrescriptionsPopUp
          buttonType="rxButton"
          variant="outlined"
          title="eRx"
          onOptionClick={(v: string) => {
            if (v === "paper_prescription") {
              prescriptionDisclosure.open();
            } else if (v === "eletronic_prescription") {
              handleElectronicPrescription();
            }
          }}
        />
        <StyleAddButton
          w="80px"
          onClick={() => ordersDisclosure.open()}
          label="Orders"
        />
        {/* administeredBy: {
                value: Object.keys(vaccine?.administeredBy)[0],
                label: Object.values(vaccine?.administeredBy)[0],
              }, */}
        <StyleAddButton
          w="80px"
          onClick={() => vaccineDisclosure.open()}
          label="Immunization"
        />
        <StyleAddButton
          w="80px"
          onClick={() => cptDisclosure.open()}
          label="Add CPT Codes"
        />
        {/* todo: need to add care plan button from figma */}
        {/* https://medarch.atlassian.net/browse/ECRH-2946 - check this ticket for more details */}
        <StyleAddButton
          w="80px"
          onClick={() => carePlanDisclosure.open()}
          label="Add Care Plan"
        />
        <StyleAddButton
          w="120px"
          onClick={() => {
            referralDisclosure.open();
          }}
          label="Referral Out"
        />
      </Flex>

      <UpsertVitalFormDrawerNew disclosureHost={addVitalDisclosure} />
      <AddCptCodes formik={formik} disclosureHost={cptDisclosure} />
      <UpsertPrescriptionForm
        prefillData={prefillData}
        setPrefillData={setPrefillData}
        disclosureHost={prescriptionDisclosure}
        readOnly={false}
        onOrder={(id: string) => getReferralPrint(id)}
        isVisitNote={true}
        icdCodes={
          formik.values?.assessmentCodes?.map((it: any) => ({
            value: it?.value,
            label: it?.code,
          })) ?? []
        }
      />

      <UpsertLabRequisitionForm disclosureHost={ordersDisclosure} />
      <UpsertVaccineDrawer
        disclosureHost={vaccineDisclosure}
        administeredBy={
          vaccineDisclosure?.data
            ? undefined
            : {
                value: me?.uuid ?? "",
                label: `${me?.firstName} ${me?.lastName}`,
              }
        }
      />
      <CarePlanTemplateModal disclosureHost={carePlanDisclosure} />

      <ReferringOutPatientWrapper
        referralDisclosure={referralDisclosure}
        referralDiagnosisCode={formik.values?.assessmentCodes?.map(
          (it: any) => ({
            value: it.value,
            label: it.code,
          })
        )}
      />
      {/* <PdfViewDrawer
        w="65vw"
        file={printViewDisclosure.data}
        disclosureHost={printViewDisclosure}
        title="Prescription"
      /> */}
      {printViewDisclosure.data && (
        <PrintPrescription
          prescriptionFormId={printViewDisclosure.data}
          onClose={() => printViewDisclosure.close()}
        />
      )}
      <PrintOrders disclosureHost={printOrderDisclosure} />
      {/* todo: need to separate out this component */}
      {showIframe && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "90%",
              height: "90%",
              backgroundColor: "white",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <Button
              onClick={handleCloseIframe}
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
                zIndex: 10000,
                backgroundColor: "white",
                color: "black",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
              variant="contained"
              size="small"
            >
              Close
            </Button>
            <iframe
              src={patientScriptsureUrl?.data}
              // src="https://ssu.scriptsure.com/profile/193676?darkmode=off&sessiontoken=fpKpd8rVbMiUe45TajD_afSyzFqSliGI"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: "8px",
              }}
              title="ScriptSure Patient Profile"
              allow="camera; microphone; geolocation"
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default PsychiatricNotePlan;

interface PrescriptionPreviewProps {
  data: any;
  onDelete?: (uuid: string) => void;
  // Edit flow is intentionally disabled for prescriptions inside the encounter.
  // Re-opening a saved prescription cleared fields and pushed blank data into the
  // summary report, so the record is now read-only here. Prop kept optional for
  // backward compatibility with existing callers.
  onEdit?: (prescription: any) => void;
}

export const PrescriptionPreview = ({
  data,
  onDelete,
}: PrescriptionPreviewProps) => {
  const printViewDisclosure = useDisclosure();

  return (
    <>
      {printViewDisclosure.data && (
        <PrintPrescription
          prescriptionFormId={printViewDisclosure.data}
          onClose={() => printViewDisclosure.close()}
        />
      )}
      <PreviewContentWrapper
        dataList={data}
        k="prescription"
        title="Prescription"
        renderContent={(prescription: any) => {
          return (
            // Block the wrapper's edit-on-click and remove the pointer cursor so
            // the prescription record reads as non-editable inside the encounter.
            <Box
              sx={{ cursor: "default", width: "100%" }}
              onClick={(e) => e.stopPropagation()}
            >
              <Text sx={{ color: "#424242" }}>
                {`OrderId: ${getFormattedId(
                  prescription?.uuid
                )} - ${camelCaseToTitle("prescriptionFormType")}: ${
                  prescription?.prescriptionFormType
                    ? replaceUnderScoreAddSpace(
                        prescription?.prescriptionFormType?.toLowerCase()
                      )
                    : ""
                } - Prescribe Date: ${NonNullableDate(
                  prescription?.prescriptionDate
                )} - Prescription Status: ${prescription?.prescriptionStatus ? replaceUnderScoreAddSpace(prescription?.prescriptionStatus?.toLowerCase()) : ""}
            `}
                {/* - duration: ${prescription?.duration}- qty: ${
                prescription?.quantity
              }- refills: ${prescription?.refills ?? ""}`} */}
              </Text>
            </Box>
          );
        }}
        onPrint={(uuid) => {
          printViewDisclosure.open(uuid);
        }}
        onDelete={onDelete}
        onEdit={() => {}}
      />
    </>
  );
};
